import { SwapDto } from '../../types/dto/Swap.dto';
import { OSNFTMetadata } from '../../types/dto/UserNFTs.dto';
import { getOpenSeaApiKey } from '../../constants/connectors';
import axios from 'axios';

export const getNFTsMetadata = async (
  swapsToParse: SwapDto[],
  chainId?: number,
): Promise<{ [address: string]: OSNFTMetadata }> => {
  const headers = getOpenSeaApiKey(chainId);
  // merge initiatorNfts and secondUserNfts into an array
  const listOfNFTsInSwaps = swapsToParse.map((swap) => swap.initiatorNfts.concat(swap.secondUserNfts)).flat();

  // creating query strings based on contract id and token id in order to query OS NFT metadata
  const NFTQueryParams = listOfNFTsInSwaps.map((nft) => {
    return (
      nft?.identifier.length > 0 &&
      nft?.token?.id.length > 0 &&
      `token_ids=${nft?.identifier.split('-')[0]}&asset_contract_addresses=${nft?.token?.id}`
    );
  });

  // OS request for metadata cannot contain more than 30 tokenIds, there's also limit on how long the query string is, so we batch by 25 to bypass both limitations
  const promises = [];
  while (NFTQueryParams.length) {
    promises.push(
      axios.get(
        `https://${
          chainId !== 1 ? 'testnets-' : ''
        }api.opensea.io/api/v1/assets?order_direction=desc&limit=50&${NFTQueryParams.splice(0, 25).join('&')}`,
        {
          headers,
        },
      ),
    );
  }

  return await Promise.all(promises)
    .then((OSMetadataResponse) => {
      return Object.assign(
        {},
        ...OSMetadataResponse.map((result) => {
          return Object.assign(
            {},
            ...result?.data?.assets.map((nft: OSNFTMetadata) => {
              const tokenIdentifier = nft.token_id.concat(`-${nft.asset_contract.address}`);
              // normalizing the data to match the subgraph metadata structure
              return {
                [tokenIdentifier]: {
                  name: nft?.name,
                  description: nft?.description,
                  image_url: nft?.image_url,
                  verified: nft?.collection['safelist_request_status'] === 'verified',
                  permalink: nft?.permalink,
                  slug: nft?.collection['slug'],
                  floorPrice: nft?.collection['floorPrice'] || '',
                },
              };
            }),
          );
        }),
      );
    })
    .catch((error) => {
      console.error(error.message);
      return {};
    });
};
